import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SettingsService } from './settings.service';
import { FilterModel } from '../models/filter.model';

@Injectable()
export class FilterService {
  constructor(private http: HttpClient) {}

  getTotals(
    name: string,
    location: string,
    affiliatedProvider: boolean,
    affiliatedProviderConsult: boolean,
    easyClaim: boolean,
    telehealth: boolean,
    latitude: string,
    longitude: string,
    distance: boolean,
    distanceKms: number,
    serviceCategory: string,
    service: string,
    specialty: string,
  ): Observable<FilterModel.ProfileTotals> {
    const params = this.buildSearchParams(
      name,
      location,
      affiliatedProvider,
      affiliatedProviderConsult,
      easyClaim,
      telehealth,
      latitude,
      longitude,
      distance,
      distanceKms,
      serviceCategory,
      service,
      specialty,
    );

    let serviceUrl = SettingsService.api.totalsByNameUrl;
    if (location) {
      serviceUrl = SettingsService.api.totalsByNameAndLocationUrl;
    } else if (latitude && longitude) {
      serviceUrl = SettingsService.api.totalsByNameAndGeolocationUrl;
    }
    if (!distance) {
      serviceUrl = SettingsService.api.totalsByNameAndGeolocationUrl;
    }

    return this.http.get(serviceUrl, { params }).pipe(
      map((response) => response as FilterModel.ProfileTotals), // revisit after angular 7 upgrade
    );
  }

  getServiceTotals(
    name: string,
    location: string,
    affiliatedProvider: boolean,
    affiliatedProviderConsult: boolean,
    easyClaim: boolean,
    telehealth: boolean,
    latitude: string,
    longitude: string,
    distance: boolean,
    distanceKms: number,
    serviceCategory: string,
    service: string,
    specialty: string,
  ): Observable<FilterModel.ProfileTotals> {
    const params = this.buildServiceSearchParams(
      name,
      location,
      affiliatedProvider,
      affiliatedProviderConsult,
      easyClaim,
      telehealth,
      latitude,
      longitude,
      distance,
      distanceKms,
      serviceCategory,
      service,
      specialty,
    );

    let serviceUrl = SettingsService.api.totalsByServiceUrl;

    if (location) {
      serviceUrl = SettingsService.api.totalsByServiceAndLocationUrl;
    } else if (latitude && longitude) {
      serviceUrl = SettingsService.api.totalsByServiceAndGeolocationUrl;
    }
    if (!distance) {
      serviceUrl = SettingsService.api.totalsByServiceAndGeolocationUrl;
    }

    return this.http.get(serviceUrl, { params }).pipe(
      map((response) => response as FilterModel.ProfileTotals), // revisit after angular 7 upgrade
    );
  }

  buildSearchParams(
    name: string,
    location: string,
    affiliatedProvider: boolean,
    affiliatedProviderConsult: boolean,
    easyClaim: boolean,
    telehealth: boolean,
    latitude: string,
    longitude: string,
    distance: boolean,
    distanceKms: number,
    serviceCategory: string,
    service: string,
    specialty: string,
  ): HttpParams {
    let params: HttpParams = new HttpParams();
    params = !name ? params : params.append('name', name);
    params = !location ? params : params.append('location', location);
    params = !serviceCategory ? params : params.append('serviceCategory', this.stripWildCards(serviceCategory));
    params = !service ? params : params.append('service', this.stripWildCards(service));
    params = !specialty ? params : params.append('specialty', this.stripWildCards(specialty));
    params = !latitude ? params : params.append('latitude', latitude.toString());
    params = !longitude ? params : params.append('longitude', longitude.toString());
    params = !distance ? params : params.append('distanceKms', distanceKms.toString());

    params = params.append('isAffiliatedProvider', affiliatedProvider.toString());

    params = params.append('isAffiliatedProviderConsult', affiliatedProviderConsult.toString());

    if (telehealth === true) {
      params = params.append('isTelehealth', telehealth.toString());
    }

    if (easyClaim === true) {
      params = params.append('isEasyClaim', easyClaim.toString());
    }

    return params;
  }

  // This looks like duplication of code. Will probably refactor at some stage unless there is a valid business case for this.
  buildServiceSearchParams(
    name: string,
    location: string,
    affiliatedProvider: boolean,
    affiliatedProviderConsult: boolean,
    easyClaim: boolean,
    telehealth: boolean,
    latitude: string,
    longitude: string,
    distance: boolean,
    distanceKms: number,
    serviceCategory: string,
    service: string,
    specialty: string,
  ): HttpParams {
    let params: HttpParams = new HttpParams();
    params = !name ? params : params.append('name', name);
    params = !location ? params : params.append('location', location);
    params = !serviceCategory ? params : params.append('serviceCategory', serviceCategory);
    params = !service ? params : params.append('service', service);
    params = !specialty ? params : params.append('specialty', specialty);
    params = !latitude ? params : params.append('latitude', latitude.toString());
    params = !longitude ? params : params.append('longitude', longitude.toString());
    params = !distance ? params : params.append('distanceKms', distanceKms.toString());

    params = params.append('isAffiliatedProvider', affiliatedProvider.toString());

    params = params.append('isAffiliatedProviderConsult', affiliatedProviderConsult.toString());

    if (telehealth === true) {
      params = params.append('isTelehealth', telehealth.toString());
    }

    if (easyClaim === true) {
      params = params.append('isEasyClaim', easyClaim.toString());
    }

    return params;
  }

  stripWildCards(term: string): string {
    if (term) {
      return term.split('%').join('');
    }
    return term;
  }
}
